import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default function getSignature(bodyType) {
    var userOptions = getUserConfiguration().UserOptions;
    return bodyType == 'HTML' ? userOptions.SignatureHtml : userOptions.SignatureText;
}
//# sourceMappingURL=getSignature.js.map